import DiagramElement from "~/helpers/workareaDiagram/diagramElement";
import ProcessFlowConst from "./processFlowConst";
import ProcessFlowStepJumpTo from "~/models/processFlows/processFlowStepJumpTo";
import {colorHelper} from "~/modules/colorHelper/app";

export default class ProcessFlowEndElement extends DiagramElement {
  jumpTo: ProcessFlowStepJumpTo;
  index: number;

  constructor(parent: DiagramElement, jumpTo: ProcessFlowStepJumpTo, isTermination: boolean, graphParent: DiagramElement) {
    super();

    this.parent = parent
    if (parent) {
      this.index = parent.children.length
      parent.children.push(this)
    }
    this.jumpTo = jumpTo
    this.isTermination = isTermination
    this.graphParent = graphParent
  }

  get const() {
    return ProcessFlowConst
  }

  get stepWidth() {
    return this.graphParent ? this.const.LoopEndWidth : this.const.StartEndWidth;
  }

  get stepHeight() {
    return  this.const.StartEndHeight;
  }

  get fullStepWidth() {
    return this.graphParent ? 250 : 500;
  }

  get client_id() {
    return this.jumpTo.client_id;
  }

  get text() {
    return this.graphParent ? 'LOOP END' : 'END';
  }

  get color() {
    return this.graphParent ? colorHelper.getTheme().endLoopStep.default : colorHelper.getTheme().endStep.default;
  }
}
